export const IS_PUBLIC_ROUTE =
  location.pathname.startsWith('/invite') ||
  location.pathname.startsWith('/auth');
